import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleInput } from "@common/toggleInput";
import { Context } from "../../context";
import { Icon } from "./icon";
import { Props } from "./types";
import styles from "./styles.scss";

function DelayToggle(_: Props) {
  const { t } = useTranslation();
  const { areDelaysToggled, toggleDelays } = React.useContext(Context);

  return (
    <div className={styles.delayToggle} onClick={toggleDelays}>
      <Icon className={styles.icon} />
      <p className={styles.text}>{t("gantt.delayToggle")}</p>
      <ToggleInput isToggled={areDelaysToggled} />
    </div>
  );
}

export { DelayToggle };
